import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import InterchangeProcessingReport
  from '../../components/InterchangeProcessingReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/InterchangeProcessingSummarySelectors';
import chart from '../../components/InterchangeProcessingChart';

export class InterchangeProcessingSummaryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showChartButton: true,
      chartMeta: chart.interchangeProcessing,
    };
  }

  render() {
    return (
      <InterchangeProcessingReport
        reportId={ReportDefinitions.INTERCHANGE_PROCESSING_SUMMARY.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        showChartButton={this.state.showChartButton}
        chartMeta={this.state.chartMeta}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
  };
}

InterchangeProcessingSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(InterchangeProcessingSummaryContainer);
